import React from 'react';
import { MainComponentBox,
  createFormData, dirtyIEHack, navTo, goBack, userHasLock } from '../../../util/util.jsx';
import $ from 'jquery';
import { List, Map } from 'immutable';
import {
  Modal,
  Button,
} from 'react-bootstrap';
import { searchDealDuplicates, clearDealDuplicates, searchBulkPaymentsDuplicates,
  clearBulkPaymentsDuplicates, updateDealFromCopy }
  from '@/component/blogic/deals/store/deal.store.js';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
moment.locale('en');
momentLocalizer();
import { clearCopy, avoidReportReset } from '@/store/allaround.store';
import { getFromTab } from '@/util/util';
import { calcPercentContractPayment, calcContractDate }
  from '@/component/blogic/deals/payments/PaymentsContainer';
import _ from 'lodash';
import store from '@/store/store';

let removeHook;
export default class BaseDealEdit extends React.Component {
  constructor(props) {
    super(props);
    this.onFromSubmitHandler = this.onFromSubmitHandler.bind(this);
    this.selectProduct = this.selectProduct.bind(this);
    this.addProduct = this.addProduct.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.yesButton = this.yesButton.bind(this);
    this.dealAddEvent = this.dealAddEvent.bind(this);
    this.dealEditEvent = this.dealEditEvent.bind(this);
    this.formChanged = this.formChanged.bind(this);
    this.handleCancelButton = this.handleCancelButton.bind(this);
    this.onUnload = this.onUnload.bind(this);
    this.saveData = this.saveData.bind(this);
    this.validateSave = this.validateSave.bind(this);
    this.searchDuplicates = this.searchDuplicates.bind(this);
    this.saveDealClicked = this.saveDealClicked.bind(this);
    this.renderDuplicates = this.renderDuplicates.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
    this.cancelPressed = false;
    this.savedNavigation = false;
    this.savePressed = false;
    this.navTo = undefined;
    this.state = { files: {},
      init: false,
      showModalHide: false,
      hidden: false,
      dealId: props.params && props.params.dealId };
  }

  componentWillMount() {
    this.props.clearDeal();
    if (this.props.params.dealId == 'new' && this.props.dealCopy) {
      this.props.updateDealFromCopy(this.props.dealCopy);
      this.props.clearCopy();
      this.setState({ fromCopy: true });
    }
    if (this.props.params.dealId !== 'new') {
      this.props.lockEntity({
        entityType: this.props.type,
        entityId: this.props.params.dealId,
      });
      this.props.loadDeal(this.props.type, this.props.params.dealId);
    }
    if (removeHook) {
      removeHook();
    }
    removeHook = this.context.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  }

  componentDidMount() {
    this.savedNavigation = false;
    dirtyIEHack();
    window.addEventListener('beforeunload', this.onUnload);
  }

  componentWillReceiveProps(props) {
    if (!props.lock && this.props.lock) {
      this.setState({ component: <MainComponentBox /> });
      this.props.lockEntity({
        entityType: this.props.type,
        entityId: this.props.params.dealId,
      });
    }
    if (props.lock != this.props.lock) {
      if (props.lock && this.props.lock) {
        if (this.props.lock.get('ownerId') == props.currentUser
          && props.lock.get('ownerId') != props.currentUser) {
          this.handleShowKickedOutModal(props.lock.get('owner'));
        }
      }
      if (!(!this.props.lock && props.lock && props.lock.get('ownerId') == props.currentUser)) {
        this.props.loadDeal(this.props.type, this.props.params.dealId);
      }
    }
    if (props.formChanged != this.props.formChanged) {
      if (removeHook) {
        removeHook();
      }
      this.context.router.setRouteLeaveHook(props.route, this.routerWillLeave);
    }
    if (props.autosaved) {
      this.savedNavigation = true;
      if (this.navTo) {
        navTo(this.navTo);
      }
    } else if (props.autosaved === false) {
      this.savePressed = false;
    }
    if (props.linkingFromListDone && this.props.products != props.products) {
      this.onFromSubmitHandler(undefined, undefined, props, true);
    } else {
      const data = props.deal;
      const dealFound = data && data.get('id');
      const shouldReload = dealFound &&
      (!this.props.deal || data.get('dealLoadedTime') != this.props.deal.get('dealLoadedTime'));
      if (!this.state.init || shouldReload) {
        // if deal has id - parse it
        if (dealFound || this.props.dealCopy) {
          // Parsing documets
          const originalFiles = data.get('documents', new List())
            .map(f => ({ file: {}, meta: f.toJS() })).toJS();
          const originalFinancialFiles = data.get('financialDocuments', new List())
            .map(f => ({ file: {}, meta: f.toJS() })).toJS();
          const files = { USUAL: originalFiles, FINANCING: originalFinancialFiles };
          // Documents to redux store
          if (this.props.storeFiles) {
            this.props.storeFiles(originalFiles, 'USUAL');
            this.props.storeFiles(originalFinancialFiles, 'FINANCING');
          }
          this.setState({ files, hidden: data.get('hidden'), init: true });
        } else if (this.props.params.dealId === 'new' &&
          this.props.params.linkToId === undefined) {
          if (this.props.addNewProduct) {
            this.props.addNewProduct();
          }
          this.setState({ init: true });
        }
      }
    }
  }

  componentDidUpdate() {
    dirtyIEHack();
  }

  componentWillUnmount() {
    if (!this.props.dealCopy || !this.props.dealCopy.size) {
      this.props.clearDeal();
    }
    window.removeEventListener('beforeunload', this.onUnload);
    if (this.props.params.dealId !== 'new') {
      this.props.unlockEntity({
        entityType: this.props.type,
        entityId: this.props.params.dealId,
      });
    }
  }

  // eslint-disable-next-line
  onUnload(event) {
    if (this.props.formChanged) {
      const message = 'There are unsaved changed on page, are you sure you want to leave?';
      // eslint-disable-next-line
      event.returnValue = message;
      return message;
    }
  }

  onFromSubmitHandler(event, reactClickEvent, props = this.props, callGoToList = false) {
    if (event) {
      event.preventDefault();
    }
    this.savePressed = true;
    this.navTo = undefined;
    return this.saveData(props, callGoToList);
  }

  getUUID(file) {
    if (file && file.meta && file.meta.uuid) {
      return file.meta.uuid;
    }
    if (file && file.file && file.file.preview) {
      const uuids = file.file.preview.split('/');
      return uuids[uuids.length - 1];
    }
    return undefined;
  }

  handleShowKickedOutModal = (owner) =>
    this.setState({ showKickedOutModal: true, newOwner: owner });
  handleHideKickOutModal = () =>
    this.setState({ showKickedOutModal: false, newOwner: '' });

  formChanged() {
    if (!this.props.formChanged) {
      this.props.handleFormChanged();
    }
  }

  routerWillLeave(routeTo) {
    // return false to prevent a transition w/o prompting the user,
    // or return a string to allow the user to decide:
    const formChanged = store.getState().getIn(['allaround', 'formChanged'], false);
    if (!this.props.loggedIn) {
      this.savePressed = false;
      return true;
    }
    if (this.savedNavigation || this.cancelPressed || !formChanged) {
      return true;
    }
    if (routeTo && routeTo.pathname.endsWith('/new')
      && this.props.dealCopy.get('dealType') == this.props.type) {
      this.cancelPressed = true;
      return true;
    }
    if (!userHasLock(this.props.type, this.props.params.dealId)) {
      return true;
    }
    if (!this.savePressed) {
      this.saveData(undefined, false, true);
    }
    this.navTo = routeTo.pathname + routeTo.search;
    this.savePressed = false;
    return false;
  }

  appendFiles(formData) {
    this.appendFilesFromList(formData, 'USUAL');
    this.appendFilesFromList(formData, 'FINANCING');
  }

  additionalAction() { }

  clearPaymentsFromDeletedFiles(payments, deletedFiles) {
    if (payments && deletedFiles) {
      payments.forEach(payment => {
        if (payment.document && payment.document.uuid) {
          if (deletedFiles.includes(payment.document.uuid)) {
            // eslint-disable-next-line
            payment.document = null;
          }
          this.clearPaymentsFromDeletedFiles(payment.payments, deletedFiles);
        }
      });
    }
  }
  saveData(props = this.props, callGoToList = true, dontReload) {
    let formData;
    const responsibleDisabled = $('input[name="responsibles"]').prop('disabled');
    switch (props.type) {
      case 'transport':
      {
        // fieldset глючит, так что пока так
        $('#vesselLoadingPorts input').prop('disabled', true);
        $('#vesselDischargePorts input').prop('disabled', true);
        $('#vesselLoadingPorts select').prop('disabled', true);
        $('#vesselDischargePorts select').prop('disabled', true);
        $('input[name="creator"]').prop('disabled', false);
        if (responsibleDisabled) {
          $('input[name="responsibles"]').prop('disabled', false);
        }
        formData = (createFormData('dealsForm'));
        if (responsibleDisabled) {
          $('input[name="responsibles"]').prop('disabled', true);
        }
        $('input[name="creator"]').prop('disabled', true);
        $('#vesselLoadingPorts input').prop('disabled', false);
        $('#vesselDischargePorts input').prop('disabled', false);
        $('#vesselLoadingPorts select').prop('disabled', false);
        $('#vesselDischargePorts select').prop('disabled', false);
        if (!formData) {
          return false;
        }
        if (this.props.deal && this.props.deal.get('freightCurrencyRates')) {
          formData.freightCurrencyRates = this.props.deal.get('freightCurrencyRates');
        }
        if (this.props.deal && this.props.deal.get('freightCurrency')) {
          formData.freightCurrency = this.props.deal.get('freightCurrency');
        }
        if (this.props.deal && this.props.deal.get('isFreightLS')) {
          formData.isFreightLS = this.props.deal.get('isFreightLS');
        }
        if (this.props.deal && this.props.deal.get('freightLSAmount')) {
          formData.freightLSAmount = this.props.deal.get('freightLSAmount');
        }
        // собираем порты
        formData.vesselLoadingPorts = props.vesselLoadingPorts
          ? props.vesselLoadingPorts.filter(port => !port.get('hidden')).toJS()
          : [];
        formData.vesselDischargePorts = props.vesselDischargePorts
          ? props.vesselDischargePorts.filter(port => !port.get('hidden')).toJS()
          : [];

        formData.payments = props.payments
          ? props.payments.toJS()
          : [];

        if (this.props.deal && this.props.deal.get('expenses')) {
          formData.expenses = this.props.deal.get('expenses');
        }

        // if (this.props.deal && this.props.deal.get('laytimeItems')) {
        //   const { loadingItems, dischargeItems, suppliersItems, buyersItems } =
        //   this.props.deal.get('laytimeItems').toJS();
        //   formData.laytimeItems = loadingItems.concat(suppliersItems)
        //   .concat(dischargeItems).concat(buyersItems)
        //   .filter(i => !i.hidden);
        // }
        formData.laytimeItems = [];
        // events
        formData.calendarEvents = [];

        break;
      }

      // sale, purchase
      default:
      {
        $('fieldset #products').prop('disabled', true);
        $('input[name="creator"]').prop('disabled', false);
        if (responsibleDisabled) {
          $('input[name="responsibles"]').prop('disabled', false);
        }
        formData = (createFormData('dealsForm'));
        $('fieldset #products').prop('disabled', false);
        if (responsibleDisabled) {
          $('input[name="responsibles"]').prop('disabled', true);
        }
        $('input[name="creator"]').prop('disabled', true);
        if (!formData) {
          return false;
        }

        if (this.props.products) {
          const filterLink = (link) => !link.get('hidden');

          // filtering by hidden
          let products = props.products.filter(prod => !prod.get('hidden'))
            .map(prod =>
              prod.set('purchaseLink',
                prod.get('purchaseLink', new List()).filter(filterLink))
                .set('saleLink', prod.get('saleLink', new List()).filter(filterLink)));
          products = products.map(prod =>
            (!prod.get('expenses') || prod.get('expenses').size == 0 ? prod :
              prod.set('expenses', prod.get('expenses')))
          );
          products = products.map(prod =>
            prod.set('payments', prod.get('payments', new List()).map(p =>
              p.set('estimatedDueAmount', calcPercentContractPayment(p, null, prod))
                .set('dueDate', calcContractDate(p, null, props.deal.get(`${props.type}Date`))))
            ).set('fixedPrice',
              prod.get('fixedPrice') === null ? true : prod.get('fixedPrice', true))
          );


          formData.products = products.toJS();
        }

        // there are no purchase/sale expenses, they are now in composite products
        formData.expenses = [];

        // events
        if (props.deal.get('calendarEvents')) {
          formData.calendarEvents = props.deal.get('calendarEvents').toJS();
        }

        break;
      }
    } // end of switch

    formData.isArchived = props.deal.get('isArchived');
    formData.hasDispute = props.deal.get('hasDispute');
    if (props.files.get('deleted')) {
      formData.filesToRemove = props.files.get('deleted').toJS();
    }

    if (this.state.fromCopy) {
      formData.documents = props.deal.get('documents');
      formData.financialDocuments = props.deal.get('financialDocuments');
    }

    if (props.params.dealId != 'new') {
      formData.id = props.params.dealId;
    }

    switch (props.type) {
      case 'transport': {
        this.clearPaymentsFromDeletedFiles(formData.payments, formData.filesToRemove);
        break;
      }
      default: {
        if (formData.products) {
          formData.products.forEach(product =>
            this.clearPaymentsFromDeletedFiles(product.payments, formData.filesToRemove));
        }
        break;
      }
    }
    this.additionalAction(formData);

    if (!this.validateSave(formData)) {
      return false;
    }

    const multiPartformData = new FormData();
    this.appendFiles(multiPartformData);

    multiPartformData.append(
      'dto',
      new Blob([JSON.stringify(formData)], { type: 'application/json' })
    );

    if (props.params.dealId == 'new') {
      return this.searchDuplicates(multiPartformData, callGoToList,
        props.tryToSave, [props.type, callGoToList, dontReload]);
    }
    return this.searchBulkPaymentsDuplicates(multiPartformData, callGoToList,
      props.tryToUpdate, [props.type, props.params.dealId, callGoToList, dontReload]);
  }

  validateSave() { return true; }

  appendFilesFromList(formData, partType) {
    let i;
    if (this.props.files.get(partType)) {
      const files = this.props.files.get(partType).toJS();
      for (i = 0; i < files.length; i++) {
        files[i].raw.meta.uuid = this.getUUID(files[i].raw);
        if (!files[i].raw.meta || !files[i].raw.meta.id) {
          formData.append(`file_${partType}_${i}`, files[i].raw.file, files[i].raw.file.name);
        }
        formData.append(`file_${partType}_${i}_meta`,
          new Blob([JSON.stringify(files[i].raw.meta)],
            { type: 'application/json' },
          ));
      }
    }
  }

  addProduct() {
    this.props.addNewProduct();
  }
  handleCancelButton() {
    this.cancelPressed = true;
    const fromTab = getFromTab();
    if (fromTab) {
      this.props.avoidReportReset();
    }
    goBack(this.props.location.pathname);
  }

  openModal() {
    this.setState({ showModal: true });
  }
  closeModal() {
    this.setState({ showModal: false });
  }
  yesButton() {
    this.setState({ showModal: false, hidden: !this.state.hidden });
  }

  selectProduct(selectId, prod) {
    const products = this.state.productsSelected.slice();
    products[selectId] = prod == null ? null : prod;
    this.setState({ productsSelected: products });
  }

  dealAddEvent(event) {
    this.props.addDealEvent(event);
  }

  dealEditEvent(oldEvent, newEvent) {
    this.props.editDealEvent(oldEvent, newEvent);
  }

  searchDuplicates(formData, callGoToList, okCallback = (() => {}), callbackAdditionalParams = []) {
    if (this.props.type != 'transport' && this.props.searchDuplicates) {
      this.setState({ formSend: { formData, callGoToList } });
      this.props.searchDuplicates(formData, okCallback, callbackAdditionalParams);
    } else {
      callbackAdditionalParams.unshift(formData);
      okCallback.apply(this, callbackAdditionalParams);
    }
  }

  searchBulkPaymentsDuplicates(formData, callGoToList, okCallback = (() => {}),
    callbackAdditionalParams = []) {
    // if (this.props.searchBulkPaymentsDuplicates) {
    //   this.setState({ formSend: { formData, callGoToList } });
    //   this.props.searchBulkPaymentsDuplicates(formData, okCallback, callbackAdditionalParams);
    // } else {
    callbackAdditionalParams.unshift(formData);
    okCallback.apply(this, callbackAdditionalParams);
    // }
  }

  saveDealClicked() {
    const { formData, callGoToList } = this.state.formSend;
    if (this.props.params.dealId == 'new') {
      return this.props.tryToSave(formData, this.props.type, callGoToList);
    }
    return this.props.tryToUpdate(formData, this.props.type,
      this.props.params.dealId, callGoToList);
  }

  bulkDuplicatesQuestion() {
    const duplicates = this.props.bulkPaymentsDuplicates || new Map();
    const hasDuplicates = duplicates.size;
    return (
      <Modal bsSize="small" show={!!hasDuplicates} onHide={this.props.clearBulkPaymentsDuplicates} >
        <Modal.Body>
          Possible duplicate bulk payment found in deals:<br />
          {this.renderDuplicates(duplicates)}
          Are you sure you want to save?
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.saveDealClicked}>Yes</Button>
          <Button onClick={this.props.clearBulkPaymentsDuplicates}>No</Button>
        </Modal.Footer>
      </Modal>
    );
  }
  renderKickOutInfo = () => <Modal
    bsSise="small"
    show={this.state.showKickedOutModal}
    onHide={this.handleHideKickOutModal}
  >
    <Modal.Body>
      <div>User {this.state.newOwner} has taken over the lock of the deal.</div>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={this.handleHideKickOutModal}>Ok</Button>
    </Modal.Footer>
  </Modal>
  renderQuestion() {
    const duplicates = this.props.duplicates || new Map();
    const hasDuplicates = duplicates.size;
    return (
      <Modal bsSize="small" show={!!hasDuplicates} onHide={this.props.clearDuplicates} >
        <Modal.Body>
          The deal that you are creating seems to be a duplicate of the deal(s):<br />
          {this.renderDuplicates(duplicates)}
          Are you sure you want to save?
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.saveDealClicked}>Yes</Button>
          <Button onClick={this.props.clearDuplicates}>No</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderDuplicates(duplicates) {
    const dealLinks = [];
    Object.keys(duplicates.toJS()).forEach(d =>
      dealLinks.push(<span>
        <a onClick={() => window.open(`/deals/${this.props.type}/${d}`, '_blank')}>
          {duplicates.get(d) || _.startCase(this.props.type)}</a><br />
      </span>));
    return dealLinks;
  }

  render() {
    return (<div />);
  }
}
BaseDealEdit.propTypes = {
  cancel: React.PropTypes.func.isRequired,
  tryToSave: React.PropTypes.func.isRequired,
  loadDeal: React.PropTypes.func.isRequired,
  tryToUpdate: React.PropTypes.func.isRequired,
  searchDuplicates: React.PropTypes.func.isRequired,
  bulkPaymentsDuplicates: React.PropTypes.object,
  searchBulkPaymentsDuplicates: React.PropTypes.func.isRequired,
  clearDuplicates: React.PropTypes.func.isRequired,
  clearBulkPaymentsDuplicates: React.PropTypes.func.isRequired,
  deal: React.PropTypes.object,
  params: React.PropTypes.object,
  lock: React.PropTypes.object,
  clearDeal: React.PropTypes.func.isRequired,
  type: React.PropTypes.string.isRequired,
  storeFiles: React.PropTypes.func,
  files: React.PropTypes.object,
  addedLinks: React.PropTypes.object,
  addDealEvent: React.PropTypes.func,
  editDealEvent: React.PropTypes.func,
  addNewProduct: React.PropTypes.func,
  lockEntity: React.PropTypes.func,
  unlockEntity: React.PropTypes.func,
  products: React.PropTypes.object,
  payments: React.PropTypes.object,
  route: React.PropTypes.object,
  formChanged: React.PropTypes.bool,
  handleFormChanged: React.PropTypes.func,
  autosaved: React.PropTypes.bool,
  loggedIn: React.PropTypes.bool,
  putError: React.PropTypes.func,
  duplicates: React.PropTypes.object,
  readonly: React.PropTypes.bool,
  clearCopy: React.PropTypes.func,
  dealCopy: React.PropTypes.object,
  updateDealFromCopy: React.PropTypes.func,
  location: React.PropTypes.object,
  avoidReportReset: React.PropTypes.func,
};
BaseDealEdit.contextTypes = {
  router: React.PropTypes.object,
  location: React.PropTypes.object,
};

export const baseDealMapStateToProps = state => ({
  duplicates: state.getIn(['data', 'deals', 'deal', 'duplicates']),
  dealCopy: state.getIn(['allaround', 'dealCopy']),
  bulkPaymentsDuplicates: state.getIn(['data', 'deals', 'deal', 'bulkPaymentsDuplicates']),
});
export const baseDealMapDispatchToProps = (dispatch, props) => ({
  searchDuplicates(formData, okCallback = (() => {}), callbackAdditionalParams = []) {
    searchDealDuplicates(dispatch, props.type, formData,
      () => {
        callbackAdditionalParams.unshift(formData);
        okCallback.apply(this, callbackAdditionalParams);
      });
  },
  clearDuplicates() {
    clearDealDuplicates(dispatch);
  },
  clearCopy() {
    clearCopy(dispatch);
  },
  updateDealFromCopy(deal) {
    updateDealFromCopy(dispatch, deal, props.type);
  },
  searchBulkPaymentsDuplicates(formData, okCallback = (() => {}), callbackAdditionalParams = []) {
    searchBulkPaymentsDuplicates(dispatch, props.type, formData,
      () => {
        callbackAdditionalParams.unshift(formData);
        okCallback.apply(this, callbackAdditionalParams);
      });
  },
  clearBulkPaymentsDuplicates() {
    clearBulkPaymentsDuplicates(dispatch);
  },
  avoidReportReset(val) {
    avoidReportReset(dispatch, val);
  },
});
